/* eslint-disable vue/html-quotes */
<template>
  <carousel
    :per-page=1
    :autoplay=true
    :loop=true
    pagination-active-color="#aa6b2c"
    pagination-color="#5a5a55"
    easing="ease"
    autoplay-timeout=3000
    autoplay-hover-pause=true
    pagination-size=16
  >
    <slide>
      <h2 class="label">
        design/build <br />
        solutions &amp; services
      </h2>
      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/spartan-carousel/spartan-build-design-01-square.jpg"
          alt="design/build solutions and services"
        />
        <source
          media="(min-width: 481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-build-design-01-tablet.jpg"
          alt="design/build solutions and services"
        />
        <source
          media="(min-width: 767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-build-design-01-med.jpg"
          alt="design/build solutions and services"
        />
        <source
          media="(min-width: 1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-build-design-01-large.jpg"
          alt="design/build solutions and services"
        />
        <source
          media="(min-width: 1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-build-design-01-xlarge.jpg"
          alt="design/build solutions and services"
        />
        <source
          media="(min-width: 1920px)"
          srcset="../assets/spartan-carousel/spartan-build-design-01-xxlarge.jpg"
          alt="design/build solutions and services"
        />
         <img
          src="../assets/spartan-carousel/spartan-build-design-01.jpg"
          alt="design/build solutions and services"
        />
      </picture>
     
    </slide>
    <slide>
      <h2 class="label">
        tenant improvements <br />
        complete finish out
      </h2>
      <picture>
        <source
          media="(max-width:480px)"
          srcset="../assets/spartan-carousel/spartan-tenant-improvements-02-square.jpg"
          alt="tenant improvements"
        />
        <source
          media="(min-width:481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-tenant-improvements-02-tablet.jpg"
          alt="tenant improvements"
        />
        <source
          media="(min-width:767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-tenant-improvements-02-med.jpg"
          alt="tenant improvements"
        />
         <source
          media="(min-width:1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-tenant-improvements-02-large.jpg"
          alt="tenant improvements"
        />
         <source
          media="(min-width:1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-tenant-improvements-02-xlarge.jpg"
          alt="tenant improvements"
        />
        <source
          media="(min-width:1921px)"
          srcset="../assets/spartan-carousel/spartan-tenant-improvements-02-xxlarge.jpg"
          alt="tenant improvements"
        />
        <img
        src="../assets/spartan-carousel/spartan-tenant-improvements-02.jpg"
        alt="tenant improvements"
        />
      </picture>
    </slide>
    <slide>
      <h2 class="label">
        framing, sheetrock <br />
        texture &amp; painting
      </h2>
      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03-square.jpg"
          alt="sheetrock framing texture"
        />
        <source
          media="(min-width: 481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03-tablet.jpg"
          alt="sheetrock framing texture"
        />
        <source
          media="(min-width: 767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03-med.jpg"
          alt="sheetrock framing texture"
        />
        <source
          media="(min-width: 1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03-large.jpg"
          alt="sheetrock framing texture"
        />
        <source
          media="(min-width: 1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03-xlarge.jpg"
          alt="sheetrock framing texture"
        />
        <source
          media="(min-width: 1921px)"
          srcset="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03-xxlarge.jpg"
          alt="sheetrock framing texture"
        />
        <img
          src="../assets/spartan-carousel/spartan-sheetrock-framing-texture-03.jpg"
          alt="sheetrock framing texture"
        >
      </picture>
    </slide>
    <slide>
      <h2 class="label">
        demolition &amp; <br />
        site work
      </h2>
      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/spartan-carousel/spartan-demolition-sitework-04-square.jpg"
          alt="demolition and sitework"
        />
        <source
          media="(min-width: 481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-demolition-sitework-04-tablet.jpg"
          alt="demolition and sitework"
        />
        <source
          media="(min-width: 767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-demolition-sitework-04-med.jpg"
          alt="demolition and sitework"
        />
        <source
          media="(min-width: 1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-demolition-sitework-04-large.jpg"
          alt="demolition and sitework"
        />
        <source
          media="(min-width: 1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-demolition-sitework-04-xlarge.jpg"
          alt="demolition and sitework"
        />
        <source
          media="(min-width: 1921px)"
          srcset="../assets/spartan-carousel/spartan-demolition-sitework-04-xxlarge.jpg"
          alt="demolition and sitework"
        />
        <img
          src="../assets/spartan-carousel/spartan-demolition-sitework-04.jpg"
          alt="demolition and sitework"
        >
      </picture>
    </slide>
    <slide>
      <h2 class="label">
        masonry, concrete<br />
        &amp; tile work
      </h2>
      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/spartan-carousel/spartan-masonry-concrete-tile-05-square.jpg"
          alt="masonry concrete and tile"
        />
         <source
          media="(min-width: 481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-masonry-concrete-tile-05-tablet.jpg"
          alt="masonry concrete and tile"
        />
        <source
          media="(min-width: 767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-masonry-concrete-tile-05-med.jpg"
          alt="masonry concrete and tile"
        />
        <source
          media="(min-width: 1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-masonry-concrete-tile-05-large.jpg"
          alt="masonry concrete and tile"
        />
        <source
          media="(min-width: 1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-masonry-concrete-tile-05-xlarge.jpg"
          alt="masonry concrete and tile"
        />
        <source
          media="(min-width: 1921px)"
          srcset="../assets/spartan-carousel/spartan-masonry-concrete-tile-05-xxlarge.jpg"
          alt="masonry concrete and tile"
        />
        <img
        src="../assets/spartan-carousel/spartan-masonry-concrete-tile-05.jpg"
        alt="masonry concrete and tile"
      >
      </picture>
    </slide>
    <slide>
      <h2 class="label">
        roof replacement<br />
        &amp; waterproofing
      </h2>
      <picture>
         <source
          media="(max-width: 480px)"
          srcset="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06-square.jpg"
          alt="roof replacement and waterproofing"
        />
        <source
          media="(min-width: 481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06-tablet.jpg"
          alt="roof replacement and waterproofing"
        />
        <source
          media="(min-width: 767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06-med.jpg"
          alt="roof replacement and waterproofing"
        />
        <source
          media="(min-width: 1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06-large.jpg"
          alt="roof replacement and waterproofing"
        />
        <source
          media="(min-width: 1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06-xlarge.jpg"
          alt="roof replacement and waterproofing"
        />
        <source
          media="(min-width: 1921px)"
          srcset="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06-xxlarge.jpg"
          alt="roof replacement and waterproofing"
        />
        <img
        src="../assets/spartan-carousel/spartan-roof-replacement-waterproofing-06.jpg"
        alt="roof replacement and waterproofing"
        >
      </picture>
    </slide>
    <slide>
      <h2 class="label">
        carpentry, millwork<br />
        &amp; cabinetry
      </h2>
      <picture>
        <source
          media="(max-width:480px)"
          srcset="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07-square.jpg"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:481px) and (max-width:768px)"
          srcset="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07-tablet.jpg"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:767px) and (max-width:1200px)"
          srcset="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07-med.jpg"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:1201px) and (max-width:1600px)"
          srcset="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07-large.jpg"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:1601px) and (max-width:1920px)"
          srcset="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07-xlarge.jpg"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:1921px)"
          srcset="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07-xxlarge.jpg"
          alt="caprentry, millwork, and cabinetry"
        />
        <img
        src="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07.jpg"
        alt="caprentry, millwork, and cabinetry"
      >
      </picture>
    </slide>

<!-- TO DELETE - JUST CHECKING LAYOUT -->
   <!--
    <slide>
      <h2 class="label">
        I am a good<br />
        &amp; wonderful puppy
      </h2>
      <picture>
        <source
          media="(max-width:480px)"
          srcset="https://picsum.photos/id/237/456/480"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:481px) and (max-width:786px)"
          srcset="https://picsum.photos/id/237/435/768"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:787px) and (max-width:960px)"
          srcset="https://picsum.photos/id/237/435/960"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:961px) and (max-width:1600px)"
          srcset="https://picsum.photos/id/237/435/1600"
          alt="caprentry, millwork, and cabinetry"
        />
        <source
          media="(min-width:1601px)"
          srcset="https://picsum.photos/id/237/435/1600"
          alt="caprentry, millwork, and cabinetry"
        />
        <img
        src="../assets/spartan-carousel/spartan-carpentry-millwork-cabinetry-07.jpg"
        alt="caprentry, millwork, and cabinetry"
      >
      </picture>
    </slide>
-->
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "SpartanCarousel",
  components: {
    Carousel,
    Slide
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";
@import "./src/stylesheets/ui/_carousel.scss";
</style>
